module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/inter_menor-0503d4bfa6e2a46dfdaf252b325140ed.png";